import { Directive, ElementRef, Input, OnChanges, OnInit } from '@angular/core';

declare var tippy: any;

@Directive({
	selector: '[appTooltip]'
})
export class TooltipDirective implements OnInit, OnChanges {
	@Input() options: any = {};
	@Input() title: any = '';

	private _el: any;
	private _host: any;
	private tippy: any = null;
	private popper: any = null;

	constructor(el: ElementRef) {
		this._el = el.nativeElement;
		this._host = el.nativeElement;
	}

	ngOnInit(): void {
		this.detectHostNode();
		this.loadTippy();
	}

	// Re-create the tooltip on changes
	ngOnChanges(changes: any): void {
		if (changes.options) {
			this.options = changes.options.currentValue;
		}

		this.detectHostNode();
		this.loadTippy();
	}

	// Detects if the directive is placed on an angular component
	// host node. The tooltip will not display correctly, so
	// instead we will transfer all data-attributes and title to the first
	// child of the component.
	detectHostNode(): void {
		const attrs = this._el.attributes;

		let hostNode = false;
		for (const attr of attrs) {
			if (attr.name.indexOf('_nghost') > -1) {
				hostNode = true;
			}
		}

		if (hostNode && this._el.children.length > 0) {
			this._el = this._el.children[0];
			this.xferAttributes(this._host, this._el);
		}
	}

	// If we are transfering the tooltip from the host component
	// node to the first child node, we'll need to copy all the data attributes
	xferAttributes(fromEl: HTMLElement, toEl: HTMLElement): void {
		const daList = [
			'position',
			'trigger',
			'interactive',
			'interactiveborder',
			'delay',
			'animation',
			'arrow',
			'arrowsize',
			'animatefill',
			'duration',
			'html',
			'size',
			'distance',
			'theme',
			'offset',
			'hideonclick',
			'multiple',
			'followcursor',
			'inertia',
			'flipduration',
			'sticky',
			'stickyduration',
			'appendto',
			'zindex',
			'touchhold',
			'performance',
			'dynamictitle',
			'popperoptions'
		];

		// Copy data attributes from the input element to the target element
		daList.forEach((da) => {
			if (fromEl.dataset[da]) {
				toEl.dataset[da] = fromEl.dataset[da];
			}
		});

		if (fromEl.hasAttribute('title')) {
			toEl.title = fromEl.title;
			fromEl.title = '';
		}
	}

	private loadTippy(): void {
		setTimeout(() => {
			if (this.tippy) {
				this.tippy.destroy(this.popper);
			}

			this.tippy = tippy(this._el, this.options);
			this.popper = this.tippy.getPopperElement(this._el);
			const el = this.tippy.getReferenceElement(this.popper);
			if (this.options.dynamicTitle && el) {
				el.setAttribute('title', this.title);
			}
		});
	}
}
